var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdo-radio"},_vm._l((_vm.labelArray),function(item,index){return _c('span',{key:index,class:{'active': item.value === _vm.value},on:{"click":function($event){return _vm.onRadioClick(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }